import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMapContext } from "@evergis/react";
import { MapControl } from "./MapControl";
import { FlexSpan, IconButton } from "../../../ui";
export const ZoomControl = props => {
    const { map } = useMapContext();
    return (_jsxs(MapControl, { ...props, column: true, children: [_jsx(FlexSpan, { display: "flex", mb: "0.88rem", children: _jsx(IconButton, { icon: "plus", onClick: () => map.zoom(1, map.position) }) }), _jsx(FlexSpan, { display: "flex", children: _jsx(IconButton, { icon: "minus", onClick: () => map.zoom(-1, map.position) }) })] }));
};
